import people from "../../Assets/Images/tab_user-plus-solid.svg";
import support from "../../Assets/Images/support_icon.svg";
import users from "src/Assets/Images/users-solid.svg";
import logout from "src/Assets/Images/logout_icon.svg";
import info_icon from "src/Assets/Images/info_icon.svg";
import i18n from 'src/i18n';

export let userSidemenuItems = [
  {
    key: 'Info',
    icon: info_icon,
    status: true,
    component: '/info',
    text: i18n.t('infoText')
  },
  {
    key: 'People',
    icon: people,
    status: false,
    component: '/people',
    text: i18n.t('people')
  },
]

export let trainerSidemenuItems = [
  {
    key: 'Customers',
    icon: users,
    status: false,
    component: '/customer',
    text: i18n.t('customers')
  },
]

export let profileItem = [
  {
    key: 'Support',
    icon: support,
    status: false,
    component: '/authSupport',
    text: i18n.t('support')
  },
  {
    key: 'Account',
    status: false,
    component: '/account',
    text: i18n.t('account')
  }
]
export let logoutItem = [
  {
    key: 'Logout',
    icon: logout,
    status: false,
    text: i18n.t('logout')
  }
]

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  userSidemenuItems[0].text = i18n.t('infoText');
  userSidemenuItems[1].text = i18n.t('people');

  trainerSidemenuItems[0].text = i18n.t('customers');
  profileItem[0].text = i18n.t('support');
  profileItem[1].text = i18n.t('account');
  logoutItem[0].text = i18n.t('logout');
}